export default __webpack_public_path__ + "static/media/moneyhash_fawry.31db272e.svg";